import * as A from '@core/arena'

export const stateKey = 'system'

export const getState = A.prop(stateKey)
